
export type GetAllUsers200Sort = {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
};
